import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import {ch5_p09} from "../../../layouts/ch5_p09/ch5_p09";

export class Chapter5Page9 extends AbstractStoryState {

    readonly bg = this.addChild(new SceneSprite());
    readonly hollyHorse = this.addChild(new SceneSprite());
    readonly tyler = this.addChild(new SceneSprite());

	readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch5_p09/"));
	readonly frameRight = this.addChild(SceneSprite.withPrefix("ch5_p09/"));
	readonly linesLeft = this.addChild(SceneSprite.withPrefix("ch5_p09/"));
	readonly linesRight = this.addChild(SceneSprite.withPrefix("ch5_p09/"));

    dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
		// exported layouts from Animate CC
        ch5_p09.call(this);

		// super.init calls onResize
		super.init(pSize, pData);
	}

	public update(pDeltaTime: number) {
		super.update(pDeltaTime);
	}

	public animateIn(pOnComplete: ()=>void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: ()=>void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
        TweenLite.delayedCall(1.5, ()=>{
            this.gotoNextState({transition: "up"});
        });
    }
}